import http from '../helpers/http';
import { getDeviceId } from '../utils';


export const register = async (payload) => {
  try {
    payload = payload || {};
    const uuid = getDeviceId();
    payload.deviceId = uuid;
    const { data } = await http.post(`/api/auth/register`, payload);
    return data;
  } catch (error) {
    const err = new Error(error?.response?.data?.message || error?.message || 'Something went wrong.');
    throw err;
  }
};

export const login = async (payload) => {
  try {
    payload = payload || {};
    const uuid = getDeviceId();
    payload.deviceId = uuid;
    const { data } = await http.post(`/api/auth/login`, payload);
    return data;
  } catch (error) {
    const err = new Error(error?.response?.data?.message || error?.message || 'Something went wrong.');
    throw err;
  }
};

export const logout = async () => {
  try {
    const { data } = await http.post(`/api/auth/logout`);
    return data;
  } catch (error) {
    const err = new Error(error?.response?.data?.message || error?.message || 'Something went wrong.');
    throw err;
  }
};
